module.exports = __webpack_public_path__ + "img/icon_cart.745bbc8.svg";